import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a2d48] text-slate-300 pt-12 pb-10 border-t border-slate-700/60 font-sans text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Centered Logo above footer content grid */}
        <div className="flex justify-center pb-8 sm:pb-10">
          <Link to="/" className="inline-block focus:outline-hidden" aria-label="Fastlane ApS Forside">
            <img
              src="/_assets/logo-negativ.png"
              alt="Fastlane ApS - Book Local Ship Global"
              className="h-11 sm:h-12 w-auto object-contain"
              width="180"
              height="48"
            />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 pb-10 border-b border-slate-700/60">
          
          {/* Column 1: Kontakt */}
          <div>
            <h3 className="text-white text-base font-semibold mb-3 underline decoration-slate-600 underline-offset-4">
              Kontakt
            </h3>
            <div className="space-y-1.5 text-xs text-slate-300">
              <p className="font-semibold text-white">Fastlane ApS</p>
              <p>Storstroemsvej 42</p>
              <p>6715 Esbjerg N</p>
              <p>Denmark</p>
              <p className="pt-1.5">
                <a href="mailto:booking@fastlane.dk" className="text-slate-300 hover:text-white transition-colors">
                  booking@fastlane.dk
                </a>
              </p>
              <p>
                <a href="tel:+4576121230" className="text-white hover:text-amber-400 font-medium transition-colors">
                  +45 76 12 12 30 (tlf)
                </a>
              </p>
              <p className="pt-1 text-slate-400">
                CVR Nr.: DK 26 63 78 13
              </p>
              <div className="pt-2 text-[11px] space-y-0.5 text-slate-400">
                <p>
                  <Link to="/betingelser" className="hover:text-slate-200 underline decoration-slate-600">Privatlivspolitik</Link>
                </p>
                <p>
                  <Link to="/betingelser" className="hover:text-slate-200 underline decoration-slate-600">Cookiepolitik</Link>
                </p>
              </div>
            </div>
          </div>

          {/* Column 2: Information & Bank Details */}
          <div>
            <h3 className="text-white text-base font-semibold mb-3 underline decoration-slate-600 underline-offset-4">
              Information
            </h3>
            <div className="space-y-1.5 text-xs text-slate-300">
              <p><strong className="text-slate-200">Bank:</strong> Sydjysk Sparekasse</p>
              <p>DKK Account: <span className="font-mono text-slate-300">7686 0000564591</span></p>
              <p>BIC-Code: <span className="font-mono text-slate-300">FROSDK21</span></p>
              <p>IBAN: <span className="font-mono text-slate-300">DK2876860000564591</span></p>
              <p className="pt-1">EURO Account: <span className="font-mono text-slate-300">7686 3050568090</span></p>
              <p>BIC-Code: <span className="font-mono text-slate-300">FROSDK21</span></p>
              <p>IBAN: <span className="font-mono text-slate-300">DK1776863050568090</span></p>
              <div className="pt-2 text-[11px]">
                <Link to="/betingelser" className="text-slate-400 hover:text-slate-200 underline decoration-slate-600">
                  Cookiepolitik
                </Link>
              </div>
            </div>
          </div>

          {/* Column 3: Location / Map & Indsend forespørgsel CTA */}
          <div className="flex flex-col items-start justify-between space-y-4">
            <div className="w-full">
              <h3 className="text-white text-base font-semibold mb-3">
                Danmark & Globalt
              </h3>
              <div className="relative rounded-sm overflow-hidden bg-slate-800/80 border border-slate-700/60 p-2 max-w-[200px]">
                <img
                  src="/_assets/map22.png"
                  alt="Transportnetværk Danmark og Europa"
                  className="w-full h-auto object-contain rounded-xs"
                  width="180"
                  height="120"
                />
              </div>
            </div>

            {/* Warm Ochre / Amber button matching fastlane.dk "Indsend forespørgsel" */}
            <div className="w-full pt-1">
              <Link
                to="/fragtrater"
                className="inline-block w-full sm:w-auto text-center bg-[#b25d19] hover:bg-[#974d12] text-white px-5 py-2.5 rounded-xs text-xs font-bold uppercase tracking-wider shadow-sm hover:shadow-md transition-all active:scale-98"
              >
                Indsend forespørgsel
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between text-[11px] text-slate-400 gap-3">
          <p>© {new Date().getFullYear()} FASTLANE ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center space-x-4 text-slate-400">
            <span>Esbjerg, Danmark</span>
            <span>•</span>
            <Link to="/betingelser" className="hover:text-slate-200">NSAB 2015 Betingelser</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
